import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Custom TitleStrategy fixing the tab-title stickiness bug.
 *
 * Angular's DefaultTitleStrategy only calls Title.setTitle() when the matched
 * route tree actually declares a `title`. A route WITHOUT a title leaves
 * document.title untouched — so navigating from a titled page (e.g. 'Uploads')
 * to a titleless one left the browser tab stuck on the PREVIOUS page's title.
 *
 * AppTitleStrategy always sets the tab on every navigation:
 *   - route has a title  → "{routeTitle} · NEPF Upload Portal"
 *   - route has no title → the bare default "NEPF Upload Portal"
 *
 * so a titleless route never inherits the prior page's tab text.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  /** Brand suffix — matches index.html's default <title>. */
  static readonly DEFAULT_TITLE = 'NEPF Upload Portal';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(
      routeTitle
        ? `${routeTitle} · ${AppTitleStrategy.DEFAULT_TITLE}`
        : AppTitleStrategy.DEFAULT_TITLE,
    );
  }
}
